var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overOns"},[_c('Hoehetbegon'),_c('Waarzijnwenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }